<ion-grid
  class="invoices-credits-tables"
  *ngIf="recentCredits.length || recentInvoices.length"
>
  <h4 data-cy="recent-invoices-credits-title">{{ translatorText.title }}</h4>
  <div class="invoices-credits-table-section" *ngIf="recentCredits.length">
    <h5 data-cy="recent-credits-title">{{ translatorText.credits }}</h5>
    <ion-list class="invoices-credits-list">
      <app-transaction-row-touch
        *ngFor="let credit of recentCredits"
        [vm]="credit"
        [translatorText]="transactionRowText"
        [canCancelPayment]="
          (cancelPaymentsService.canCancelPayment$() | async) &&
          credit.status === Status.PENDING
        "
        [showOrderNumber]="showOrderNumber"
        [isMobile]="isMobile"
        (moreOptionsClickEmitter)="openMoreOptions($event)"
        (viewInvoiceClickEmitter)="viewInvoice($event)"
      ></app-transaction-row-touch>
    </ion-list>
  </div>

  <div *ngIf="!recentCredits.length && recentInvoices.length">
    <h5 data-cy="recent-credits-title">{{ translatorText.credits }}</h5>
    <h5 data-cy="no-recent-credits-message">
      {{ translatorText.noRecentActivity }}
    </h5>
  </div>

  <div class="invoices-credits-table-section" *ngIf="recentInvoices.length">
    <h5 data-cy="recent-invoices-title">{{ translatorText.invoices }}</h5>
    <ion-list class="invoices-credits-list">
      <app-transaction-row-touch
        *ngFor="let invoice of recentInvoices"
        [vm]="invoice"
        [translatorText]="transactionRowText"
        [canCancelPayment]="
          (cancelPaymentsService.canCancelPayment$() | async) &&
          invoice.status === Status.PENDING
        "
        [showOrderNumber]="showOrderNumber"
        [isPayable]="paymentsEnabled"
        [isMobile]="isMobile"
        (moreOptionsClickEmitter)="openMoreOptions($event)"
        (viewInvoiceClickEmitter)="viewInvoice($event)"
      ></app-transaction-row-touch>
    </ion-list>
  </div>

  <div *ngIf="!recentInvoices.length && recentCredits.length">
    <h5 data-cy="recent-invoices-title">{{ translatorText.invoices }}</h5>
    <h5 data-cy="no-recent-invoices-message">
      {{ translatorText.noRecentActivity }}
    </h5>
  </div>
</ion-grid>

<ion-grid *ngIf="!recentCredits.length && !recentInvoices.length">
  <app-empty-states [title]="translatorText.noRecentActivity">
  </app-empty-states>
</ion-grid>
